import { META_KEY } from "./constants";
export var defineMetadata = function (target, key, prop) {
    if (!target[META_KEY])
        target[META_KEY] = {};
    target[META_KEY][key] = prop;
};
export var getMetadata = function (target, key) {
    return target[META_KEY] && target[META_KEY][key];
};
//# sourceMappingURL=reflect-metadata-polyfill.js.map